import classNames from "classnames";
import React, { useState } from "react";

export default function ({
  children,
  className,
  textAlign,
  marginBottom = 0,
  posX = "left",
  posY = "top",
}) {
  const [styles, setStyles] = useState({});

  const onMouseOver = (e) => {
    const coords = e.currentTarget.getBoundingClientRect();
    const newStyles = {
      visibility: "visible",
      opacity: 1,
    };

    if (posY === "top") {
      newStyles.top = coords.top + coords.height + marginBottom;
      console.log(newStyles.top);
    }
    if (posX === "left") {
      newStyles.left = coords.left;
    }
    if (textAlign) {
      newStyles.textAlign = textAlign;
    }

    setStyles(newStyles);
  };

  const onMouseOut = (e) => {
    setStyles({});
  };

  return (
    <div className={classNames("form-item-info", { [className]: !!className })}>
      <div
        className="form-item__info-btn"
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
      >
        i
      </div>
      <p className="form-item__info-block" style={styles}>
        {children}
      </p>
    </div>
  );
}
